import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m13.995 3.065-1.06-1.06L8 6.94 3.065 2.005l-1.06 1.06L6.94 8l-4.92 4.92 1.06 1.065L8 9.06l4.92 4.925 1.06-1.065L9.06 8z"
    }, null, -1)
  ])))
}
export default { render: render }